<script lang="ts" setup>
import { computedStatusColor } from '~/utils/utils-js'

// export type Size = 'small' | 'normal' | 'large'
const props = defineProps<{
  saleStatusId: number
  saleStatus: string
}>()
const statusColor = computed(() => computedStatusColor(props))
</script>

<template>
  <tag :color="statusColor">
    {{ saleStatus }}
  </tag>
</template>

<style lang="scss" scoped>

</style>
